/**
 * Created by rathompson on 10/25/21
 * File: ClientCredentials
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo, useState } from 'react'
import { defineMessage, useIntl } from 'react-intl'
import {
  Tooltip,
  Button
} from '@panwds/react-ui'
import { EyeIcon, EyeSlashIcon } from '@panwds/icons'
import { DATA_TEST_SHOW_HIDE_PASSWORD } from '../../constants/TestingDataIds'

const showMessage = defineMessage({
  id: 'show_password',
  defaultMessage: 'Show',
  description: 'Display text',
})

const hideMessage = defineMessage({
  id: 'hide_password',
  defaultMessage: 'Hide',
  description: 'Hide text',
})

/**
 *   Password show/hide button for password inputs
 */
const PasswordViewButton = ({
  defaultState,
  appearance,
  iconSize,
  size,
  onClick,
  text,
  ...passThrough
}) => {
  const intl = useIntl()

  const [isShowing, setIsShowing] = useState(defaultState)
  const label = useMemo(() => intl.formatMessage(defineMessage(isShowing ? hideMessage : showMessage)), [intl, isShowing])
  const icon = useMemo(() => (isShowing ? <EyeIcon size={iconSize} /> : <EyeSlashIcon size={iconSize} />), [iconSize, isShowing])

  return (
    <Tooltip label={label}>
      <Button
        data-testid={DATA_TEST_SHOW_HIDE_PASSWORD}
        aria-label={label}
        onClick={(e) => {
          setIsShowing(!isShowing)
          onClick?.(e)
        }}
        {...{ ...passThrough, size, appearance, icon }}
      />
    </Tooltip>
  )
}

PasswordViewButton.defaultProps = {
  defaultState: false,
  appearance: 'tertiary-clear',
  iconSize: 'md',
  size: 'md',
  disabled: false
}

export default PasswordViewButton
